// extracted by mini-css-extract-plugin
module.exports = {"comments":"W_dJ","comments__list":"W_dK"};